import { render, staticRenderFns } from "./ProfileMain.vue?vue&type=template&id=2c5563f5&scoped=true&"
import script from "./ProfileMain.vue?vue&type=script&lang=js&"
export * from "./ProfileMain.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMain.vue?vue&type=style&index=0&id=2c5563f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5563f5",
  null
  
)

export default component.exports